import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="px-4 md:px-6 pb-6">
      <div className="mx-auto max-w-7xl rounded-3xl bg-foreground-950 px-8 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h3 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-3">Stay Updated</h3>
            <p className="text-foreground-400 text-sm leading-relaxed mb-8 max-w-sm">
              Get the latest spreadsheet guides, agent shopping tips, and exclusive updates delivered straight to your inbox.
            </p>
            <form
              data-readdy-form
              id="newsletter-form"
              action="https://readdy.ai/api/form/d95tlh2h9roq6qfrca7g"
              method="POST"
              className="flex flex-col gap-3"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = formData.get("website_alt") as string;
                if (honeypot && honeypot.trim() !== "") {
                  const msg = document.getElementById("newsletter-msg");
                  if (msg) { msg.textContent = "Thank you for subscribing!"; msg.className = "text-accent-400 text-sm mt-2"; }
                  form.reset();
                  return;
                }
                try {
                  const body = new URLSearchParams();
                  for (const [k, v] of formData.entries()) {
                    if (k !== "website_alt" || !(v as string).trim()) {
                      body.append(k, v as string);
                    }
                  }
                  const res = await fetch(form.action, { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: body.toString() });
                  const text = await res.text();
                  let parsed: any = {};
                  try { parsed = JSON.parse(text); } catch { /* ignore parse errors */ }
                  const msg = document.getElementById("newsletter-msg");
                  if (res.ok && parsed?.code === "OK") {
                    if (msg) { msg.textContent = "Thank you for subscribing!"; msg.className = "text-accent-400 text-sm mt-2"; }
                    form.reset();
                  } else {
                    const errMsg = parsed?.meta?.message || parsed?.message || "Something went wrong. Please try again.";
                    if (msg) { msg.textContent = errMsg; msg.className = "text-red-400 text-sm mt-2"; }
                  }
                } catch {
                  const msg = document.getElementById("newsletter-msg");
                  if (msg) { msg.textContent = "Network error. Please try again."; msg.className = "text-red-400 text-sm mt-2"; }
                }
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                className="bg-transparent border-b border-foreground-600 text-background-50 placeholder-foreground-500 pb-2 text-sm outline-none focus:border-background-50 transition-colors"
              />
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-anti-spam" />
              <button type="submit" className="px-6 py-2.5 bg-background-50 text-foreground-950 rounded-full text-sm font-medium hover:bg-background-100 transition-colors flex items-center gap-2 self-start cursor-pointer whitespace-nowrap">
                Subscribe
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
              <span id="newsletter-msg" className="text-sm mt-2"></span>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-label text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline">Home</Link>
              <Link to="/articles/cssbuy-sheet-complete-guide" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline">CSSBuy Sheet Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline">kaspreadsheet.com</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline">Buy Now</a>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-label text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">Contact</h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:hello@cssspreadsheet.com" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline">hello@cssspreadsheet.com</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline">Visit Main Site</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 text-sm hover:text-background-50 transition-colors underline">Main Site</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 text-sm hover:text-background-50 transition-colors underline">Shop</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 text-sm hover:text-background-50 transition-colors underline">Categories</a>
          </div>
          <p className="text-foreground-600 text-sm">&copy; 2026 CSSSpreadsheet.com. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/" className="text-foreground-500 text-sm hover:text-background-50 transition-colors underline">Home</Link>
            <Link to="/articles/cssbuy-sheet-complete-guide" className="text-foreground-500 text-sm hover:text-background-50 transition-colors underline">Guide</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}